import React from "react";
import { useLang } from "@/lib/i18n";
import { useSettings } from "@/lib/SettingsContext";

// Used until the admin fills Settings > Media sosial; an empty admin value keeps the default.
export const DEFAULT_SOCIAL = {
  social_instagram_url: "https://www.instagram.com/mindovia.yourspace/",
  social_tiktok_url: "https://www.tiktok.com/@mindovia",
  social_facebook_url: "https://www.facebook.com/profile.php?id=61595883291025",
};

const ICONS = {
  instagram: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.6-2.6 2.6 2.6 0 0 1 3.37-2.48V9.66a5.68 5.68 0 0 0-6.46 5.64A5.69 5.69 0 0 0 9.86 21a5.69 5.69 0 0 0 5.69-5.69V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.25-1.48Z" />
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
      <path d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.87.25-1.46 1.5-1.46h1.5V4.46A20 20 0 0 0 14.3 4.3c-2.17 0-3.66 1.33-3.66 3.76v2.44H8.2v3h2.44V21h2.86Z" />
    </svg>
  ),
};

const NETWORKS = [
  ["instagram", "Instagram", "social_instagram_url"],
  ["tiktok", "TikTok", "social_tiktok_url"],
  ["facebook", "Facebook", "social_facebook_url"],
];

export function socialLinks(settings) {
  const s = settings || {};
  return NETWORKS
    .map(([key, label, field]) => ({ key, label, url: (s[field] || "").trim() || DEFAULT_SOCIAL[field] }))
    .filter((l) => l.url);
}

function Icons({ links, testid }) {
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      {links.map((l) => (
        <a
          key={l.key}
          href={l.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={l.label}
          title={l.label}
          className="w-9 h-9 rounded-full border border-border bg-card flex items-center justify-center text-foreground/70 hover:text-terracotta-600 hover:border-terracotta-300 transition-colors"
          data-testid={`social-${l.key}`}
        >
          {ICONS[l.key]}
        </a>
      ))}
    </div>
  );
}

// Footer row of social icons.
export default function SocialLinks() {
  const { settings } = useSettings();
  const links = socialLinks(settings);
  if (!links.length) return null;
  return <Icons links={links} testid="footer-social-links" />;
}

// "Follow Mindovia" card shown under results and shared result cards.
export function FollowMindovia() {
  const { lang } = useLang();
  const { settings } = useSettings();
  const links = socialLinks(settings);
  if (!links.length) return null;
  return (
    <div className="mt-10 p-5 rounded-2xl border border-border bg-cream-50/60 flex flex-wrap items-center justify-between gap-4 print:hidden" data-testid="follow-mindovia">
      <div>
        <div className="font-display text-base">{lang === "id" ? "Suka tes ini? Ikuti Mindovia" : "Enjoyed this test? Follow Mindovia"}</div>
        <div className="text-sm text-muted-foreground">
          {lang === "id" ? "Dapatkan info tes baru dan konten seru seputar kenal diri." : "Get new tests and bite-sized self-discovery content."}
        </div>
      </div>
      <Icons links={links} testid="follow-mindovia-links" />
    </div>
  );
}
